﻿import { SalesOrderSetInfo } from '~/features/catalog/components/article/SalesOrderSetInfo.tsx';
import { ArticleInfoButton } from '~/features/catalog/components/ArticleInfoButton.tsx';
import { PriceBadgeGroup } from '~/common/components/PriceBadgeGroup.tsx';
import type { IArticlePriceGraduatedPriceStepDtoData } from '~/dtos/ProdegaApiWebshop-api-typings-generated.ts';
import { cn } from '~/common/utils/styleUtil.ts';

export default function ArticleInfoIcons({
  article,
  className,
  isAuthenticated
}: Readonly<{
  className?: string;
  article: {
    mainArticleId: number;
    isHit?: boolean;
    isProfitPlus: boolean;
    isTransit: boolean;
    isInSalesOrderSet: boolean;
    graduatedPriceSteps?: IArticlePriceGraduatedPriceStepDtoData[];
    noveltyUntil: boolean;
  };
  isAuthenticated: boolean;
}>) {
  return (
    <div className={cn('gap-2 min-w-0', className)}>
      {article.isInSalesOrderSet && <SalesOrderSetInfo />}
      <ArticleInfoButton article={article} reserveSpace={false} />
      <PriceBadgeGroup
        badges={[
          ...(article.graduatedPriceSteps?.length ? [{ type: 'gross' as const }] : []),
          ...(article.noveltyUntil ? [{ type: 'new' as const }] : []),
          ...(article.isHit && isAuthenticated ? [{ type: 'hit' as const }] : [])
        ]}
      />
    </div>
  );
}
